'use client';

import { useEffect } from 'react';
import { HeaderClientWrapper } from './components/header/HeaderClientWerpper';
import FooterClientWrapper from './components/footer/FooterClientWrapper';
import { getUserLocale } from '@/hotdesk-ui/lib/language.service';
import NotFoundErrorWrapper from './not-found/notFoundErrorWrapper';
export default async function Error({
  error
}: {
  error: Error & {
    digest?: string;
  };
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Error:', error);
  }, [error]);
  const languageCode = await getUserLocale();
  return <>
            <HeaderClientWrapper languageCode={languageCode} isDirectory={false} data-sentry-element="HeaderClientWrapper" data-sentry-source-file="error.tsx" />
            <NotFoundErrorWrapper data-sentry-element="NotFoundErrorWrapper" data-sentry-source-file="error.tsx" />
            <FooterClientWrapper languageCode="en" data-sentry-element="FooterClientWrapper" data-sentry-source-file="error.tsx" />
        </>;
}